export abstract class MachinesEvent {}

export class MachinesLoad extends MachinesEvent {}
